import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { HtsClassificationJobsStore } from '../../helpers/services/hts-classification-jobs.store';
import { HtsJobAttentionItem, HtsJobsAttentionSummary } from '../../helpers/services/hts-classification-jobs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-ai-classifications-tray',
  templateUrl: './ai-classifications-tray.component.html',
  styleUrls: ['./ai-classifications-tray.component.scss'],
  standalone: false,
})
export class AiClassificationsTrayComponent implements OnInit {
  readonly summary$: Observable<HtsJobsAttentionSummary | null> = this.jobs.summary$;
  readonly badgeCount$: Observable<number> = this.summary$.pipe(
    map(summary => (summary?.needsAnswer ?? 0) + (summary?.ready ?? 0)),
  );

  constructor(private readonly jobs: HtsClassificationJobsStore, private readonly router: Router) {}

  ngOnInit(): void { this.jobs.startPolling(); }

  itemsFor(summary: HtsJobsAttentionSummary | null, status: string): HtsJobAttentionItem[] {
    return (summary?.items ?? []).filter(item => item.status === status);
  }

  open(item: HtsJobAttentionItem): void {
    if (item.rfqId != null && item.rfqItemId != null) {
      void this.router.navigate(['/apps/rfq'], { queryParams: {
        htsDeterminationId: item.determinationId,
        htsRfqId: item.rfqId,
        htsRfqItemId: item.rfqItemId,
      }});
      return;
    }
    void this.router.navigate(['/apps/rfq/lookup'], {
      queryParams: { htsDeterminationId: item.determinationId },
    });
  }

  viewAll(): void { void this.router.navigate(['/apps/rfq/lookup']); }
}
